import gql from 'graphql-tag';

const UPLOAD_BULK_IMPORT_FILE_MUTATION = gql`
  mutation uploadBulkImportFileMutation($data: BulkImportFileUploadInput!) {
    uploadBulkImportFile(data: $data) {
      url
      fields
    }
  }
`;

export default UPLOAD_BULK_IMPORT_FILE_MUTATION;
